<div class="modal-header" *ngIf="isModal">
  <h5 class="modal-title">{{'spedizioni.editTitle' | translate}}</h5>
  <div>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <button type="save" class="close" (click)="save()" aria-label="Close">
      <span aria-hidden="true"><i class="fas fa-save"></i></span>
    </button>
  </div>
</div>
<div [ngClass]="{'modal-body': isModal, 'card': !isModal}">
  <div [ngClass]="{'card-body': !isModal}">
    <div class="row" >
      <div class="col-sm-12 col-md-12">
        <div class="form-group">
          <label for="data" class="control-label col-form-label">{{'spedizioni.data' | translate}}:</label>
          <input type="date" [(ngModel)]="item.data"  class="form-control" id="data">
        </div>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">{{'spedizioni.numero' | translate}}</label>
        <input type="text" #numero="ngModel" required [placeholder]="'spedizioni.numero' | translate" [(ngModel)]="item.numero" name="nome" class="form-control">
        <small class="form-text text-danger" *ngIf="!numero.valid && (numero.dirty || numero.touched)"> required</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">{{'spedizioni.shipper' | translate}}</label>
        <input type="text" #shipper="ngModel" required [placeholder]="'spedizioni.shipper' | translate" [(ngModel)]="item.shipper" name="nome" class="form-control">
        <small class="form-text text-danger" *ngIf="!shipper.valid && (shipper.dirty || shipper.touched)"> required</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">{{'spedizioni.destinazione' | translate}}</label>
        <input type="text" #destinazione="ngModel" required [placeholder]="'spedizioni.destinazione' | translate" [(ngModel)]="item.destinazione" name="nome" class="form-control">
        <small class="form-text text-danger" *ngIf="!destinazione.valid && (destinazione.dirty || destinazione.touched)"> required</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">{{'spedizioni.porto_partenza' | translate}}</label>
        <input type="text" #porto_partenza="ngModel" required [placeholder]="'spedizioni.porto_partenza' | translate" [(ngModel)]="item.porto_partenza" name="nome" class="form-control">
        <small class="form-text text-danger" *ngIf="!porto_partenza.valid && (porto_partenza.dirty || porto_partenza.touched)"> required</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">{{'spedizioni.porto_destinazione' | translate}}</label>
        <input type="text" #porto_destinazione="ngModel" required [placeholder]="'spedizioni.porto_destinazione' | translate" [(ngModel)]="item.porto_destinazione" name="nome" class="form-control">
        <small class="form-text text-danger" *ngIf="!porto_destinazione.valid && (porto_destinazione.dirty || porto_destinazione.touched)"> required</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">{{'spedizioni.nave' | translate}}</label>
        <input type="text" #nave="ngModel" required [placeholder]="'spedizioni.nave' | translate" [(ngModel)]="item.nave" name="nome" class="form-control">
        <small class="form-text text-danger" *ngIf="!nave.valid && (nave.dirty || nave.touched)"> required</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">{{'spedizioni.partenza' | translate}}</label>
        <input type="date" #partenza="ngModel" required [placeholder]="'spedizioni.partenza' | translate" [(ngModel)]="item.partenza" name="nome" class="form-control">
        <small class="form-text text-danger" *ngIf="!partenza.valid && (partenza.dirty || partenza.touched)"> required</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">{{'spedizioni.arrivo' | translate}}</label>
        <input type="date" #arrivo="ngModel" required [placeholder]="'spedizioni.arrivo' | translate" [(ngModel)]="item.arrivo" name="nome" class="form-control">
        <small class="form-text text-danger" *ngIf="!arrivo.valid && (arrivo.dirty || arrivo.touched)"> required</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">{{'spedizioni.partenza_prevista' | translate}}</label>
        <input type="date" #partenza_prevista="ngModel" required [placeholder]="'spedizioni.partenza_prevista' | translate" [(ngModel)]="item.partenza_prevista" name="nome" class="form-control">
        <small class="form-text text-danger" *ngIf="!partenza_prevista.valid && (partenza_prevista.dirty || partenza_prevista.touched)"> required</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">{{'spedizioni.data_limite' | translate}}</label>
        <input type="date" #data_limite="ngModel" required [placeholder]="'spedizioni.data_limite' | translate" [(ngModel)]="item.data_limite" name="nome" class="form-control">
        <small class="form-text text-danger" *ngIf="!data_limite.valid && (data_limite.dirty || data_limite.touched)"> required</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">{{'spedizioni.agenzia' | translate}}</label>
        <input type="text" #agenzia="ngModel" required [placeholder]="'spedizioni.agenzia' | translate" [(ngModel)]="item.agenzia" name="nome" class="form-control">
        <small class="form-text text-danger" *ngIf="!agenzia.valid && (agenzia.dirty || agenzia.touched)"> required</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">{{'spedizioni.indirizzo_partenza' | translate}}</label>
        <textarea type="text" #indirizzo_partenza="ngModel"  [placeholder]="'spedizioni.indirizzo_partenza' | translate" [(ngModel)]="item.indirizzo_partenza" name="nome" class="form-control"></textarea>
        <small class="form-text text-danger" *ngIf="!indirizzo_partenza.valid && (indirizzo_partenza.dirty || indirizzo_partenza.touched)"> required</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">{{'spedizioni.indirizzo_destinazione' | translate}}</label>
        <input type="text" #indirizzo_destinazione="ngModel"  [placeholder]="'spedizioni.indirizzo_destinazione' | translate" [(ngModel)]="item.indirizzo_destinazione" name="nome" class="form-control">
        <small class="form-text text-danger" *ngIf="!indirizzo_destinazione.valid && (indirizzo_destinazione.dirty || indirizzo_destinazione.touched)"> required</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">{{'spedizioni.container' | translate}}</label>
        <input type="number" min="1" #container="ngModel"  [placeholder]="'spedizioni.container' | translate" [(ngModel)]="item.container" name="container" class="form-control">
        <small class="form-text text-danger" *ngIf="!container.valid && (container.dirty || container.touched)"> required</small>
      </div>
      <div class="col-lg-3 form-group">
        <label class="mb-0 text-dark">{{'spedizioni.tipo_container' | translate}}</label>
        <input type="text" #tipo_container="ngModel"  [placeholder]="'spedizioni.tipo_container' | translate" [(ngModel)]="item.tipo_container" name="nome" class="form-control">
        <small class="form-text text-danger" *ngIf="!tipo_container.valid && (tipo_container.dirty || tipo_container.touched)"> required</small>
      </div>
      <div class="col-lg-12 form-group">
        <label class="mb-0 text-dark">{{'spedizioni.note' | translate}}</label>
        <textarea #note="ngModel"  [placeholder]="'spedizioni.note' | translate" [(ngModel)]="item.note" name="nome" class="form-control"></textarea>
        <small class="form-text text-danger" *ngIf="!note.valid && (note.dirty || note.touched)"> required</small>
      </div>
    </div>
  </div>
</div>
<div class="card">
  <div class="card-body">
    <app-voci-di-costo
      *ngIf="item && item.voci"
      [isModifyDisabled]="false"
      [HasIva]="false"
      [HasTotale]="false"
      [HasPrezzo]="false"
      [HasProdottiDropdown]="false"
      [externalAddFunction]="true"
      [externalEditFunction]="true"
      [externalDeleteFunction]="true"
      [prezzoEditabile]="false"
      [voceEditabile]="false"
      (AddClicked)="EditVoce()"
      (UpdateClicked)="EditVoce($event)"
      (DeleteClicked)="DeleteVoce($event)"
      [CampiAggiuntivi]="[{nome: 'Ordine di Acquisto', oggetti: ['ordine']}]"
      [HasUm]="false"
      [myProp]="item"
      [title]="'Beni da spedire'"
      (resetpage)="refresh()
"></app-voci-di-costo>
    <app-file-uploader *ngIf="item?.id" [url]="'/primanota/spedizioni/file'" [(listafile)]="item.files" [(id)]="item.id" (onChange)="refresh()" ></app-file-uploader>
  </div>
</div>
<div class="d-md-flex align-items-center p-3" style="padding-right: 25px;">
  <button (click)="save()" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
    <span class="ml-1 text-white font-weight-bold"> <i class="fas fa-save"></i> {{'spedizioni.salva' | translate}} </span>
  </button>
</div>
